export interface FeatureFlagDefaults {
  enabled: boolean
  value?: unknown
}

// Дефолты на случай, если backend недоступен. Ключи те же, что в
// FeatureToggleBundle/Service/FeatureFlagCatalog; ключей без гейта в коде здесь быть не должно.
export const DEFAULT_FEATURE_FLAGS: Record<string, FeatureFlagDefaults> = {
  advanced_filters: { enabled: false },
  advanced_search_enabled: { enabled: false },
  analytics_enabled: { enabled: false },
  chat_enabled: { enabled: false },
  supplier_showcase_enabled: { enabled: false },
  tender_enabled: { enabled: false },
  tender_extended_enabled: { enabled: false },
  procurement_enabled: { enabled: false },
}

export function isAuthEndpoint(url: string | undefined): boolean {
  if (!url) return false
  return (
    url.includes('/auth/login') ||
    url.includes('/auth/register') ||
    url.includes('/auth/refresh')
  )
}
